import { useAnchorable } from '../../hooks/useAnchorable';

import { codeBlock, pre } from './CodeBlock.css';
import type { TPostCodeBlockProps } from './CodeBlock.types';

export const PostCodeBlock = (props: TPostCodeBlockProps) => {
  const { element } = props;
  const { anchorAttributes } = useAnchorable(element?.attrs);

  const html = element?.attrs?.data?.highlighted_code || element?.content?.[0]?.text;

  return (
    <div {...anchorAttributes} className={codeBlock}>
      <pre className={pre}>
        <code dangerouslySetInnerHTML={{ __html: html }} />
      </pre>
    </div>
  );
};
